<template>
  <div>
    <a-row>
          <g-master name="forms"
                    @params="paramsTable"
                    :endpoint="formMaster.endpoint"
                    :tableSetup="formMaster.tableSetup"
                    :modalFieldsSetup="formMaster.modalFieldsSetup"
                    modalWidth="90%"
                    ref="jobsAccess"
                    :parentData="jbParentData"
                    @action="masterAction"
          >
            <template slot="customButton">
              <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
            </template>
            <template slot="masterModal" slot-scope="{record}">
              <a-row :gutter="[16,16]">
                <a-col v-if="$getConfigValue('MOSTRAR_CAMPO_CARGO_ACCESO_AL_TRABAJO', true) !== 'NO'" v-bind="colOptions">
                  <g-dropdown endpoint="jobs"
                              :label="$t('Cargo')"
                              :formItemConfig="fiOptions"
                              :decorator="['id_job', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                  >
                  </g-dropdown>
                </a-col>
                <a-col v-if="$getConfigValue('MOSTRAR_CAMPO_OFICINA_ACCESO_AL_TRABAJO', true) !== 'NO'" v-bind="colOptions">
                  <g-dropdown endpoint="offices"
                              :label="$t('Oficina')"
                              :formItemConfig="fiOptions"
                              :decorator="['office_id', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                  >
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Salario Max')">
                    <a-input-number style="width: 100%" step="1"
                                    v-decorator="['sal_max', { rules: [{ required: false}] }]"
                                    :formatter="value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                    :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                    ></a-input-number>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Salario Medio')">
                    <a-input-number style="width: 100%" step="1"
                                    v-decorator="['sal_medio', { rules: [{ required: false}] }]"
                                    :formatter="value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                    :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                    ></a-input-number>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Salario Minimo 1')">
                    <a-input-number style="width: 100%" step="1"
                                    v-decorator="['sal_min1', { rules: [{ required: false}] }]"
                                    :formatter="value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                    :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                    ></a-input-number>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Salario Minimo 2')">
                    <a-input-number style="width: 100%" step="1"
                                    v-decorator="['sal_min2', { rules: [{ required: false}] }]"
                                    :formatter="value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                    :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                    ></a-input-number>
                  </a-form-item>
                </a-col>
              </a-row>
            </template>
          </g-master>
    </a-row>
    <a-modal
      title="Editar"
      width="90%"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="guardarValadicXPuesto"
      @cancel="handleCancel"
    >
      <a-row :gutter="[16,16]">
        <a-form-model layout="vertical" :model="iJobsAccess" :rules="formRules"
                      @submit.native.prevent ref="jobsAccessModal">

          <a-col v-bind="colSpan">
            <a-form-model-item v-bind="fiOptions" :label="$t('Salario Max')" prop="sal_max">
              <a-input-number style="width: 100%" step="1"
                              v-model=iJobsAccess.sal_max
                              :formatter="value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                              :parser="value => value.replace(/\$\s?|(,*)/g, '')">
              </a-input-number>
            </a-form-model-item>
          </a-col>

          <a-col v-bind="colSpan">
            <a-form-model-item v-bind="fiOptions" :label="$t('Salario Medio')" prop="sal_max">
              <a-input-number style="width: 100%" step="1"
                              v-model=iJobsAccess.sal_medio
                              :formatter="value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                              :parser="value => value.replace(/\$\s?|(,*)/g, '')">
              </a-input-number>
            </a-form-model-item>
          </a-col>

          <a-col v-bind="colSpan">
            <a-form-model-item v-bind="fiOptions" :label="$t('Salario Minimo 1')" prop="sal_max">
              <a-input-number style="width: 100%" step="1"
                              v-model=iJobsAccess.sal_min1
                              :formatter="value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                              :parser="value => value.replace(/\$\s?|(,*)/g, '')">
              </a-input-number>
            </a-form-model-item>
          </a-col>

          <a-col v-bind="colSpan">
            <a-form-model-item v-bind="fiOptions" :label="$t('Salario Minimo 2')" prop="sal_max">
              <a-input-number style="width: 100%" step="1"
                              v-model=iJobsAccess.sal_min2
                              :formatter="value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                              :parser="value => value.replace(/\$\s?|(,*)/g, '')">
              </a-input-number>
            </a-form-model-item>
          </a-col>
        </a-form-model>
      </a-row>
    </a-modal>
  </div>
</template>

<script>
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    mounted () {
      this.httpClient = new HttpUtil('job_access')
    },
    data () {
      return {
        colSpan: {
          xs: 24,
          md: 12,
          sm: 12
        },
        iJobsAccess: {},
        visible: false,
        confirmLoading: false,
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        formMaster: {
          endpoint: 'job_access',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Cargo', dataIndex: 'job_name', sorter: true},
              {title: 'Oficina', dataIndex: 'office_name', sorter: true},
              {title: 'Salario Maximo', dataIndex: 'sal_max', sorter: true},
              {title: 'Salario Medio', dataIndex: 'sal_medio', sorter: true},
              {title: 'Salario Minimo 1', dataIndex: 'sal_min1', sorter: true},
              {title: 'Salario Minimo 2', dataIndex: 'sal_min2', sorter: true}
            ],
            actions: {
              actions: [
                {
                  name: 'customEdit',
                  text: 'Editar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'edit'}
                },
                {
                  name: 'customDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link'}
                }
              ]
            }
          },
          modalFieldsSetup: [
            {name: 'office_id'},
            {name: 'id_job'},
            {name: 'sal_max'},
            {name: 'sal_medio'},
            {name: 'sal_min1'},
            {name: 'sal_min2'}
          ]
        },
        endpointExcel: 'job_access_/downloadExcel',
        fileNameExcel: 'AccesoAlTrabajo',
        paramsT: {}
      }
    },
    methods: {
      initFormRules () {
        this.formRules = {
          name: [{required: true, message: 'Valor requerido'}]
        }
      },
      guardarValadicXPuesto (e) {
        this.confirmLoading = true
        return new Promise((resolve, reject) => {
          this.httpClient.getInstance().put('job_access/rnd', {
            ...this.iJobsAccess
          })
            .then(() => {
              this.$refs.jobsAccess.$refs.datatable.loadData()
              resolve()
            })
            .catch((error) => {
              Mensajes.error('Error', 'No fue posible actualizar el registro')
              reject(error)
            }).then(() => {
              this.visible = false
              this.confirmLoading = false
            })
        })
      },
      handleCancel (e) {
        this.visible = false
      },
      masterAction (action) {
        switch (action.action) {
          case 'customEdit':
            this.iJobsAccess = {...action.record}
            this.visible = true
            break
          case 'customDelete':
            this.$confirm({
              title: 'Confirmación',
              content: '¿Está seguro que desea eliminar el registro?',
              onOk: () => {
                return new Promise((resolve, reject) => {
                  this.httpClient.getInstance().delete('job_access/rnd', {
                    data: action.record
                  })
                    .then(() => {
                      this.$refs.jobsAccess.$refs.datatable.loadData()
                      resolve()
                    })
                    .catch((error) => {
                      Mensajes.error('Error', 'No fue posible eliminar el registro')
                      reject(error)
                    })
                })
              },
              onCancel () {
              }
            })
            break
        }
      },
      paramsTable (params) {
        this.paramsT = params
      }
    },
    props: ['jobId'],
    computed: {
      jbParentData () {
        return {
          id_job: this.jobId
        }
      },
      paramsExcel () {
        return {...this.paramsT, columns: this.formMaster.tableSetup.columns, ...this.jbParentData}
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Jobs/JobsAccess.vue